import React from "react";
import { CalendarDays, Loader2, Play } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyState({ onScan, scanBusy }) {
  return (
    <div
      className="rounded-lg border border-dashed border-slate-300 bg-white p-10 text-center"
      data-testid="openhouses-empty"
    >
      <div className="mx-auto h-12 w-12 rounded-full bg-amber-100 flex items-center justify-center mb-3">
        <CalendarDays className="h-6 w-6 text-amber-600" />
      </div>
      <h3 className="text-base font-semibold text-slate-900 font-display">
        No open houses yet
      </h3>
      <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">
        Run a Realtor.ca scan to pull this week's open houses into your agenda. Each scan
        costs about $0.10 in Apify compute and finishes in under a minute.
      </p>
      {onScan ? (
        <Button
          onClick={onScan}
          disabled={scanBusy}
          className="mt-4 text-white min-h-[44px]"
          style={{ background: "hsl(var(--brand))" }}
          data-testid="empty-state-scan-button"
        >
          {scanBusy ? (
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          ) : (
            <Play className="h-4 w-4 mr-2" />
          )}
          Run first scan
        </Button>
      ) : null}
    </div>
  );
}
